import { ofType } from 'redux-observable';
import { of } from 'rxjs/observable/of';
import { catchError } from 'rxjs/operators/catchError';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { AuthService, InactivityService } from '../../services';
import {
  types as actions,
  loggedOutAction,
  logoutErrorAction
} from '../../reducers/actions';

export default function(action$) {
  return action$.pipe(
    ofType(actions.LOG_OUT),
    switchMap(action => {
      InactivityService.stop();
      return AuthService.revoke().pipe(
        map(data => loggedOutAction()),
        catchError(error => of(logoutErrorAction(error)))
      )
    })
  );
}



// WEBPACK FOOTER //
// ./src/epics/auth/logout.js